// SERVICES
import TokenManager from './createTokenManager.js';

/** 
 * A wrapper around the native fetch API that automatically injects the JWT access token and handles token refreshing.
 * 
 * @param   {string} url - The URL or endpoint to fetch.
 * @param   {RequestInit} [options={}] - The standard fetch options (headers, method, body, etc.).
 * @returns {Promise<Response>} Resolves with the server Response if successful or after a successful refresh.
 * @throws  {string} Rejects with "Session expired" and redirects to /login if refresh fails.
 */
export default async function fetchWithToken(url, options = {}) {
    const headers = {
        ...options.headers,
        "Authorization": `Bearer ${TokenManager.getToken()}`
    };

    let response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
        console.warn("Access token expired. Attempting refresh...");

        const refreshSuccessful = await TokenManager.refresh();

        if (refreshSuccessful) {
            headers["Authorization"] = `Bearer ${TokenManager.getToken()}`;
            response = await fetch(url, { ...options, headers });
        } else {
            console.error("Refresh token invalid. Redirecting to login.");
            
            window.location.replace("/login"); 
            
            return Promise.reject("Session expired");
        }
    }

    return response;
};